import * as React from "react";
import { Spinner } from "react-bootstrap";

const Pageloader = () => {
  return (
    <div className="surveypro-loader">
      <center>
        <Spinner animation="border" as="span" style={{ color: "#7c4d94" }} />
        <div className="h4" style={{ color: "#7c4d94", fontWeight: 600 }}>Loading...</div>
      </center>
    </div>
  );
};

export default Pageloader;